import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/fundmanage',
    meta: { title: '资金管理' },
    component: Layout,
    redirect: '/fundmanage/list',
    children: [
      {
        path: 'list',
        meta: { title: '资金管理', activeMenu: '/fundmanage/list' },
        component: () => import('@/views/bondRecord/BondRecord3.vue')
      },
      {
        path: 'detail',
        meta: { title: '资金详情', activeMenu: '/fundmanage/list' },
        component: () => import('@/views/bondRecord/BondRecordDetail3.vue')
      },
      {
        path: 'approval',
        meta: { title: '资金审批', activeMenu: '/fundmanage/list' },
        component: () => import('@/views/bondRecord/FundApproval.vue')
      },
      {
        path: 'add',
        meta: { title: '资金管理', activeMenu: '/fundmanage/list' },
        component: () => import('@/views/bondRecord/BondRecordAdd3.vue')
      }
    ]
  },
  {
    path: '/bondRecord',
    meta: { title: '保证金管理' },
    component: Layout,
    redirect: '/bondRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '保证金管理', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '保证金详情', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '保证金管理', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecordAdd.vue')
      },
      {
        path: 'quickadd',
        meta: { title: '快捷充值', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecordAdd2.vue')
      }

    ]
  },
  {
    path: '/goodsRecord',
    meta: { title: '货款管理' },
    component: Layout,
    redirect: '/goodsRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '货款管理', activeMenu: '/goodsRecord' },
        component: () => import('@/views/goodsRecord/BondRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '货款详情', activeMenu: '/goodsRecord' },
        component: () => import('@/views/goodsRecord/BondRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '货款管理', activeMenu: '/goodsRecord' },
        component: () => import('@/views/goodsRecord/BondRecordAdd.vue')
      },
      {
        path: 'quickadd',
        meta: { title: '快捷充值', activeMenu: '/goodsRecord' },
        component: () => import('@/views/bondRecord/BondRecordAdd2.vue')
      }

    ]
  }

]
